import { useState as o, useMemo as V, useEffect as C } from "react";
import { isEmpty as h, transformTag as _ } from "./index.es3.js";
import { putInterest as x } from "./index.es4.js";
import { API_URL as v } from "./index.es6.js";
const J = (i, g, y) => {
  const [t, n] = o({
    followActive: !1,
    alertActive: !1,
    distributionChannels: [],
    includeAlerts: []
  }), [A, a] = o(!1), [p, r] = o(!1), [I, E] = o(!1), [F, D] = o(!1), S = (e) => {
    D(e);
  }, l = (e) => {
    const s = i.frequency ? v.RECOMMENDED_INTERESTS : v.INTERESTS;
    return x(s, e, S);
  }, k = async () => {
    const e = {
      ...t,
      followActive: !0,
      alertActive: !0,
      frequency: i.frequency ?? "As published",
      tag: {
        ...t.tag,
        distributionChannels: ["email"]
      }
    };
    delete e.interestId;
    const s = await l([e]);
    n({ ...s[0] }), r(!1);
  }, w = async () => {
    const e = {
      ...t,
      followActive: !1,
      alertActive: !1,
      tag: {
        ...t.tag,
        distributionChannels: []
      }
    }, s = await l([e]);
    n({
      ...e,
      followActive: s[0].followActive,
      includeAlerts: s[0].includeAlerts,
      tag: {
        ...t.tag,
        distributionChannels: s[0].tag.distributionChannels
      }
    }), r(!1);
  }, q = async () => {
    t.followActive ? g || (r(!0), await w()) : (r(!0), await k()), g && !p && a(!A);
  }, L = async (e) => {
    const s = await l({ ...t, includeAlerts: e });
    n({ ...s[0] });
  }, M = async (e) => {
    const s = await l({ ...t, frequency: e });
    n({ ...s[0] });
  }, O = async () => {
    var b;
    let e = ((b = t == null ? void 0 : t.tag) == null ? void 0 : b.distributionChannels) || [], s = (t == null ? void 0 : t.includeAlerts) || [];
    !e.includes("email") ? (e.push("email"), s.includes("event") || s.push("event")) : (e = e.filter((f) => f !== "email"), s = s.filter((f) => f !== "event"));
    const c = !h(e);
    let u = {};
    u = {
      ...t,
      alertActive: c,
      distributionChannels: e,
      tag: {
        ...t.tag,
        distributionChannels: e
      }
    };
    const d = await l([u]);
    n({ ...d[0] });
  }, R = async () => {
    var d;
    let e = ((d = t == null ? void 0 : t.tag) == null ? void 0 : d.distributionChannels) || [];
    !e.includes("mobile") ? e.push("mobile") : e = e.filter((b) => b !== "mobile");
    const m = !h(e);
    let c = {};
    c = {
      ...t,
      distributionChannels: e,
      alertActive: m,
      tag: {
        ...t.tag,
        distributionChannels: e
      }
    };
    const u = await l([c]);
    n({ ...u[0] });
  }, T = () => {
    let e = (t == null ? void 0 : t.includeAlerts) || [];
    e.includes("event") ? e = e.filter((s) => s !== "event") : e.push("event"), L(e);
  }, j = (e) => {
    switch (e) {
      case "email":
        O();
        break;
      case "mobile":
        R();
        break;
      case "event":
        T();
        break;
    }
  }, B = async () => {
    await w(), a(!1);
  }, U = () => {
    a(!1);
  }, N = V(() => {
    var e;
    return ((e = t.tag) == null ? void 0 : e.distributionChannels) || [];
  }, [t]);
  return C(() => {
    (async () => {
      if (i) {
        const s = _(i);
        n(s);
      }
    })();
  }, [i]), C(() => {
    var e;
    E(!h(((e = t.tag) == null ? void 0 : e.distributionChannels) || []));
  }, [t]), y ? {
    isError: F,
    interest: t,
    isFollowLoading: p,
    showBellIcon: I,
    dropdownVisible: A,
    setDropdownVisible: a,
    hideMenu: U,
    distributionChannels: N,
    onFrequencyChange: M,
    handleFollow: q,
    handleUnFollow: B,
    toggleAlerts: j
  } : null;
};
export {
  J as useRecommendFollow
};
//# sourceMappingURL=index.es12.js.map
